import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage12(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(
    refs.glowCircle.current,
    {
      alpha: 0,
      duration: 5,
    },
    'stage12'
  )
    .to(
      refs.buttons.action.current,
      {
        scale: 0.75,
        x: -19,
        duration: 5,
      },
      'stage12'
    )
    .to(
      refs.buttons.decor.current,
      {
        scale: 0.75,
        x: 19,
        duration: 5,
      },
      'stage12'
    );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage12',
    animations: [
      {
        x: vw(0.355),
        y: vh(0.009),
        duration: 5,
      },
      {
        x: vw(0.455),
        y: vh(-0.245),
        duration: 5,
      },
      {
        x: vw(-0.14),
        y: vh(0.043),
        duration: 5,
      },

      {
        x: vw(0.162),
        y: vh(-0.362),
        duration: 5,
      },

      {
        x: vw(-0.358),
        y: vh(-0.345),
        duration: 5,
      },
      undefined,
      {
        x: vw(-0.454),
        y: vh(-0.108),
        duration: 5,
      },
    ],
  });
}
